


import { array, boolean, number, object, string } from "yup";

const indianIFSCRegEx = new RegExp("^[A-Z]{4}0[A-Z0-9]{6}$");
// const panCardRegEx = new RegExp("/^[A-Z]{5}[0-9]{4}[A-Z]$/");

const loginSchema = object({
  email: string().required("Required").email("Invalid email ID"),
  password: string().required("Required").min(8, "Password must be at least 8 characters"),
});

const signUpschema = object({
  firstName: string().trim().required("Required"),
  lastName: string().trim().required("Required"),
  email: string().trim().required("Required").email("Invalid email ID"),
  password: string().trim().required("Required").min(8, "Password must be at least 8 characters"),
  phoneNumber: string().matches(/^[0-9]*$/, 'Only numbers are allowed').required('Required'),
});

const commisionFormSchema = object({
  retroComission: number().typeError('Invalid').required("Required")
    .test('is-number', 'Must be a number', (value) => {
      return !isNaN(value);
    }),
  firstRetroPartnerName: string(),
  firstRetroPartnerCommission: number().typeError('Invalid')
  // .test('is-number', 'Must be a number', (value) => {
  //   return !isNaN(value);
  // }),
  ,
  secondRetroPartnerName: string(),
  secondRetroPartnerCommission: number()
});


const legalDetailsIndianFormSchema = object({
  panNumber: string().matches(/^[A-Z]{5}[0-9]{4}[A-Z]$/, 'Invalid').required("Required"),
  gstCheck: boolean(),
  gstNumber: string().when("gstCheck", {
    is: false,
    then: schema => schema
      .matches(
        /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[0-9A-Z][0-9A-Z]{1}$/,
        'Incorrect format'
      )
      .required("required"),
    otherwise: schema => schema.notRequired(),
  }),
  msmeCheck: boolean(),
  msmeNumber: string().when("msmeCheck", {
    is: true,
    then: schema => schema
        .matches(/^[a-zA-Z0-9]{12}$/,
        'Incorrect format'
      )
      .required("required"),
    otherwise: schema => schema.notRequired(),
  }),
  msmeCertificate: string().when("msmeCheck", {
    is: true,
    then: schema => schema
      .required("required"),
    otherwise: schema => schema.notRequired(),
  }),
  termsCheck: boolean().oneOf([true], 'Kindly accept the Terms and Conditions'),
  confirmationCheck: boolean().oneOf([true], 'Kindly confirm the declaration'),
});

const legalDetailsNonIndianFormSchema = object({
  taxId: string().required("Required"),
  termsCheck: boolean().oneOf([true], 'Kindly accept the Terms and Conditions').required('Required'),
  confirmationCheck: boolean().oneOf([true], 'Kindly confirm the declaration').required('Required'),
});

const bankDetailsIndianFormSchema = object({
  bankName: string().required("Required"),
  accountName: string().required("Required"),
  accountNumber: string().required("Required"),
  ifscCode: string().required("Required").matches(indianIFSCRegEx, "Incorrect format"),
  branchName: string(),
  branchCode: string(),
  branchAddress: string().required("Required"),
});

const bankDetailsIndianMandateFormSchema = object({
  bankName: string().required("Required"),
  accountName: string().required("Required"),
  accountNumber: string()
    .required("Required")
    .matches(/^\d+$/, "Account number must only contain digits")
    .min(8, "Account number must be at least 8 digits")
    .max(16, "Account number must be at most 16 digits"),
  ifscCode: string().required("Required").matches(indianIFSCRegEx, "Incorrect format"),
  branchName: string().required("Required"),
  branchCode: string(),
  branchAddress: string().required("Required"),
  customer_bank_account_type: string().required("Required"),
  max_deposit_amount: string().required("Required"),
  eMandate: boolean()
    .oneOf([true], "You must accept eMandate")  // ✅ always required
    .required("You must accept eMandate"),
});

const bankDetailsNonIndianFormSchema = object({
  isUsingOnlineBankingPartner: string(),
  bankingPartner: string().required("Required"),
  otherOnlineBankingPartner: string().when('bankingPartner', {
    is: 'Others',
    then: () => string().required("Required")
  }),
  accountName: string().required("Required"),
  accountNumber: string().required("Required"),
  accountType: string(),
  iban: string().when("accountType", {
    is: "iban",
    then: () => string().required("Required"),
  }),
  swift: string().when("accountType", {
    is: "swift",
    then: () => string().required("Required"),
  }),
  bankName: string().required("Required"),
  branchAddress: string().required("Required"),
  country: string().required("Required"),
  accountAddress: string().required("Required"),
});

const newAccountSchema = object({
  accountID: string().required("Required"),
});

const replyToRequestSchema = object({
  content: string().required("Required"),
  attachments: string(),
});

const requestSchema = object({
  adsAccount: string().required("Required"),
  requestType: string().required("Required"),
  description: string().required("Required"),
  attachments: string(),
});

const adAccountRequestSchema = object({
  companyName: string().required("Required"),
  // description: string().required("Required"),
  landingPage: string().url('Invalid format'),
  creativeDriveLinks: string().url('Invalid format').required('Required'),
  verifiedBmId: string().required("Required"),
  screenshotOfBusinessInfo: string(),
  accountTimezone: string().required("Required"),
  accountType: string().required("Required"),
  currency: string(),
  confirmationCheck: boolean().oneOf([true], 'You must confirm').required("Required"),
});

const editAdAccountRequestSchema = object({
  companyName: string().required("Required"),
  description: string().required("Required"),
  landingPage: string().url('Invalid format'),
  creativeDriveLinks: string().url('Invalid format').required('Required'),
  verifiedBmId: string().required("Required"),
  screenshotOfBusinessInfo: string().required("Required"),
  accountTimezone: string().required("Required"),
  accountType: string().required("Required"),
  currency: string(),
  adsAccountId: string().required("Required"),
  adsAccountName: string().required("Required"),
  initialBalance: number().typeError('Must be a number'),
  businessAccount: string().required("Required"),
  facebookPages: array()
    .min(1, "Required"),
  pixels: array()
    .min(1, "Required"),
});

const newCompanySchema = object({
  nickName: string().required("Required"),
  companyName: string().required("Required"),
  typeOfBussiness: string().required("Required"),
  companyType: string().required("Required"),
  registerAddress: string().required("Required").min(10, "Please enter minimum 10 characters"),
  correspondenceAddress: string().required("Required").min(10, "Please enter minimum 10 characters"),
  otherBusinessType: string(),
  websiteUrl: string().required("Required"),//.matches(URLRegEx, 'Invalid'),
  serviceDescription: string().required("Required"),
  representativeName: string().required("Required"),
  representativePhone: string().required("Required"),
  representativeEmail: string().required("Required"),
  representativeDesignation: string().required("Required"),
  ownerName: string(),
  ownerPhone: string(),
});

const newClientSchema = object({
  firstName: string().required("Required"),
  phoneNumber: string().matches(/^[0-9]*$/, 'Only numbers are allowed').required('Required'),
  lastName: string(),
  email: string().required("Required").email("Invalid email ID"),
  password: string().required("Required").min(8, "Password must be at least 8 characters"),
  role: string().required("Required"),
});

const assignClientSchema = object({
  clientId: string().required("Required"),
});

const editRequestSchema = object({
  checked: string().required("Required"),
  notes: string(),
});

const transferFormSchema = object({
  fromAdsAccount: string().required("Required"),
  toAdsAccount: string().required("Required"),
  amount: string().required("Required"),
});

const legalDetailsNonIndianVerificationSchema = object({
  registrationCertificate: object({
    isApproved: string(),
    reason: string().when("isApproved", {
      is: false,
      then: string().required("required"),
    }),
    notes: string(),
  }),
});

const legalDetailsIndianVerificationSchema = object({
  registrationCertificate: object({
    isApproved: string(),
    reason: string().when("isApproved", {
      is: false,
      then: string().required("required"),
    }),
    notes: string(),
  }),
});

const approvalCardSchema = object({
  reason: string(),
  isApproved: string(),
  notes: string(),
});

const sumOfpercentSplit = (values) => {
  const total = values?.reduce((acc, value) => acc + (value?.percent || 0), 0);
  // console.log(values);
  return total === 100;

};

const topUpRequestSchema = object({
  currency: string().required("required"),
  amount: string().required("required"),
  accountType: string(),
  paymentEntityName: string().required("required"),
  paymentProvider: string().required("required"),
  paymentProviderOther: string(),
  transactionId: string().required("required"),
  paymentReceipt: string().required("required"),
  transferredTo: string().required("required"),
  transferredFrom: string().required("required"),
  percentSplit: array().of(
    object().shape({
      percent: number()
        .min(0, 'Amount must be a positive number')
        .max(100, 'Amount cannot be more than 100')
    })
  ).test('sumOfRepeater', 'Percent split sum must be 100%', sumOfpercentSplit),
  amountReceived:
    number("Invalid")
      .positive("Must be a positive value").when(
        'amount',
        (amount, schema) => schema.max(amount, 'Amount received cannot be greater than client entered amount')
      )

});

const topUpRequestSchemaForNonIndian = object({
  currency: string().required("required"),
  amount: string().required("required"),
  accountType: string(),
  paymentEntityName: string().required("required"),
  paymentProvider: string().required("required"),
  paymentProviderOther: string(),
  transactionId: string().required("required"),
  paymentReceipt: string().required("required"),
  transferredTo: string().required("required"),
  transferredFrom: string().required("required"),
  percentSplit: array().of(
    object().shape({
      percent: number()
        .min(0, 'Amount must be a positive number')
        .max(100, 'Amount cannot be more than 100')
    })
  ).test('sumOfRepeater', 'Percent split sum must be 100%', sumOfpercentSplit),
  amountReceived:
    number("Invalid")
      .positive("Must be a positive value").when(
        'amount',
        (amount, schema) => schema.max(amount, 'Amount received cannot be greater than client entered amount')
      )

});


const updateTopUpRequestSchema = object({
  currency: string().required("required"),
  amount: string().required("required"),
  accountType: string(),
  paymentEntityName: string().required("required"),
  paymentProvider: string().required("required"),
  paymentProviderOther: string(),
  transactionId: string().required("required"),
  paymentReceipt: string().required("required"),
  transferredTo: string().required("required"),
  transferredFrom: string().required("required"),
  percentSplit: array().of(
    object().shape({
      percent: number()
        .min(0, 'Amount must be a positive number')
        .max(100, 'Amount cannot be more than 100')
    })
  ).test('sumOfRepeater', 'Percent split sum must be 100%', sumOfpercentSplit),
  amountReceived:
    number("Invalid")
      .positive("Must be a positive value").when(
        'amount',
        (amount, schema) => schema.max(amount, 'Amount received cannot be greater than client entered amount')
      )
});

const approveTopUpSchema = object({
  approve: boolean(),
  reply: string().when("approve", {
    is: false,
    then: () => string().required("required"),
  }),
  amountReceived: number().when("approve", {
    is: true,
    then: () => string().required("required"),
  }),
});

const confirmTopUpSchema = object({
  confirm: boolean().oneOf([true], 'required').required("required")
});

const adUplaodSchema = object().shape({
  adsAccountName: array()
    .of(string().required("Account name is required"))
    .min(1, "At least one Ad Account is required"),
  files: array().min(1, 'File is required'),
});

const campaignFormSchema = object({
  adsAccounts: array()
    .min(1, "At least one Ad Account is required"),
  name: string().required('Campaign name is required'),
  objective: string().required('Objective is required'),
  budget: string().required('Budget type is required'),
  daily_budget: number().when('budget', {
    is: 'daily_budget',
    then: schema => schema.required('Daily budget is required').min(1, 'Daily budget must be a positive number'),
    otherwise: schema => schema.notRequired(),
  }),

  lifetime_budget: number().when('budget', {
    is: 'lifetime_budget',
    then: schema => schema.required('Lifetime budget is required').min(1, 'Lifetime budget must be a positive number'),
    otherwise: schema => schema.notRequired(),
  }),
});

const salesFormSchema = object().shape({
  name: string().required('Ad Set name is required'),
  destination_type: string()
    .oneOf(['WEBSITE', 'PHONE_CALL', 'WEBSITE_AND_PHONE_CALL', 'APP','WHATSAPP'], 'Invalid conversion location')
    .required('Conversion location is required'),

  optimization_goal: string()
    .oneOf(
      [
        'OFFSITE_CONVERSIONS',
        'LINK_CLICKS',
        'LANDING_PAGE_VIEWS',
        'VALUE',
        'QUALITY_CALL',
        'REACH',
        'CONVERSATIONS',
        'IMPRESSIONS',
      ],
      'Invalid performance goal'
    )
    .required('Performance goal is required'),

  billing_event: string()
    .oneOf(['IMPRESSIONS', 'LINK_CLICKS'], 'Invalid billing event')
    .required('Billing event is required'),

  budget: string().required('Budget type is required'),
  bid_amount: number().when('bid_strategy', {
    is: (val) => ['LOWEST_COST_WITH_BID_CAP', 'COST_CAP'].includes(val),
    then: schema => schema.required('Required').positive('must be a positive number'),
    otherwise: schema => schema.notRequired()
  }),
  roas_average_floor: number().when('bid_strategy', {
    is: 'LOWEST_COST_WITH_MIN_ROAS',
    then: schema => schema.required('Required').positive('must be a positive number'),
    otherwise: schema => schema.notRequired()
  }),
  daily_budget: number().when('budget', {
    is: 'daily_budget',
    then: schema => schema.required('Daily budget is required').min(1, 'Daily budget must be a positive number'),
    otherwise: schema => schema.notRequired(),
  }),

  lifetime_budget: number().when('budget', {
    is: 'lifetime_budget',
    then: schema => schema.required('Lifetime budget is required').min(1, 'Lifetime budget must be a positive number'),
    otherwise: schema => schema.notRequired(),
  }),

  geo_locations: array().required('Location is required')
    .test('not-empty', 'Location is required', value => {
      return value && Object.keys(value).length > 0;
    }),
  promoted_object: array().when('optimization_goal', {
      is: (goal) => goal === 'OFFSITE_CONVERSIONS',
      then: () =>
        array()
          .required('Promoted object is required for OFFSITE_CONVERSIONS'),
      otherwise: () => array().notRequired()
  }),
  facebookPages: array().when(['optimization_goal', 'destination_type'], {
    is: (goal, destinationType) => 
      goal === 'QUALITY_CALL' || destinationType === 'WHATSAPP',
    then: () =>
      array()
        .required('Facebook page id is required')
        .min(1, 'Facebook page id is required')
        .of(
          object().shape({
            adsAccountId: string().required('adsAccountId is required'),
            page_id: string().required('page_id is required for QUALITY_CALLS'),
          })
        )
        .test(
          'has-page-id',
          'At least one object must have page_id',
          (value) => value && value.some(obj => obj.page_id)
        ),
    otherwise: () => array().notRequired(),
  }),
});

const salesCampaignFormSchema = object().shape({
  name: string().required('Ad Set name is required'),

  destination_type: string()
    .oneOf(['WEBSITE', 'PHONE_CALL', 'WEBSITE_AND_PHONE_CALL', 'APP', 'WHATSAPP'], 'Invalid conversion location')
    .required('Conversion location is required'),

  optimization_goal: string()
    .oneOf(
      [
        'OFFSITE_CONVERSIONS',
        'LINK_CLICKS',
        'LANDING_PAGE_VIEWS',
        'VALUE',
        'QUALITY_CALL',
        'REACH',
        'CONVERSATIONS',
        'IMPRESSIONS',
      ],
      'Invalid performance goal'
    )
    .required('Performance goal is required'),

  billing_event: string()
    .oneOf(['IMPRESSIONS', 'LINK_CLICKS'], 'Invalid billing event')
    .required('Billing event is required'),

  budget: string().required('Budget type is required'),
  bid_amount: number().when('bid_strategy', {
    is: (val) => ['LOWEST_COST_WITH_BID_CAP', 'COST_CAP'].includes(val),
    then: schema => schema.required('Required').positive('must be a positive number'),
    otherwise: schema => schema.notRequired()
  }),
  roas_average_floor: number().when('bid_strategy', {
    is: 'LOWEST_COST_WITH_MIN_ROAS',
    then: schema => schema.required('Required').positive('must be a positive number'),
    otherwise: schema => schema.notRequired()
  }),
  daily_budget: number().when('budget', {
    is: 'daily_budget',
    then: schema => schema.required('Daily budget is required').min(1, 'Daily budget must be a positive number'),
    otherwise: schema => schema.notRequired(),
  }),

  lifetime_budget: number().when('budget', {
    is: 'lifetime_budget',
    then: schema => schema.required('Lifetime budget is required').min(1, 'Lifetime budget must be a positive number'),
    otherwise: schema => schema.notRequired(),
  }),

  geo_locations: array().required('Location is required')
    .test('not-empty', 'Location is required', value => {
      return value && Object.keys(value).length > 0;
    }),
  promoted_object: array().when('optimization_goal', {
    is: (goal) => goal === 'OFFSITE_CONVERSIONS',
    then: () =>
      array()
        .required('Promoted object is required for OFFSITE_CONVERSIONS'),
    otherwise: () => array().notRequired()
  }),
  facebookPages: array().when(['optimization_goal', 'destination_type'], {
    is: (goal, destinationType) => 
      goal === 'QUALITY_CALL' || destinationType === 'WHATSAPP',
    then: () =>
      array()
        .required('Facebook page id is required')
        .min(1, 'Facebook page id is required')
        .of(
          object().shape({
            adsAccountId: string().required('adsAccountId is required'),
            page_id: string().required('page_id is required for QUALITY_CALLS'),
          })
        )
        .test(
          'has-page-id',
          'At least one object must have page_id',
          (value) => value && value.some(obj => obj.page_id)
        ),
    otherwise: () => array().notRequired(),
  }),
});

const salesFormUpdateSchema = object().shape({
  name: string().required('Ad Set name is required'),

  destination_type: string()
    .oneOf(['WEBSITE', 'PHONE_CALL', 'WEBSITE_AND_PHONE_CALL', 'APP', 'WHATSAPP'], 'Invalid conversion location')
    .required('Conversion location is required'),

  optimization_goal: string()
    .oneOf(
      [
        'OFFSITE_CONVERSIONS',
        'LINK_CLICKS',
        'LANDING_PAGE_VIEWS',
        'VALUE',
        'QUALITY_CALL',
        'REACH',
        'CONVERSATIONS',
        'IMPRESSIONS',
      ],
      'Invalid performance goal'
    )
    .required('Performance goal is required'),

  billing_event: string()
    .oneOf(['IMPRESSIONS', 'LINK_CLICKS'], 'Invalid billing event')
    .required('Billing event is required'),

  budget: string().required('Budget type is required'),
  bid_amount: number().when('bid_strategy', {
    is: (val) => ['LOWEST_COST_WITH_BID_CAP', 'COST_CAP'].includes(val),
    then: schema => schema.required('Required').positive('must be a positive number'),
    otherwise: schema => schema.notRequired()
  }),
  roas_average_floor: number().when('bid_strategy', {
    is: 'LOWEST_COST_WITH_MIN_ROAS',
    then: schema => schema.required('Required').positive('must be a positive number'),
    otherwise: schema => schema.notRequired()
  }),
  daily_budget: number().when('budget', {
    is: 'daily_budget',
    then: schema => schema.required('Daily budget is required').min(1, 'Daily budget must be a positive number'),
    otherwise: schema => schema.notRequired(),
  }),

  lifetime_budget: number().when('budget', {
    is: 'lifetime_budget',
    then: schema => schema.required('Lifetime budget is required').min(1, 'Lifetime budget must be a positive number'),
    otherwise: schema => schema.notRequired(),
  }),

  geo_locations: array().required('Location is required')
    .test('not-empty', 'Location is required', value => {
      return value && Object.keys(value).length > 0;
    }),
});

const salesFormSchematrackEdit = object().shape({
  name: string().required('Ad Set name is required'),
  destination_type: string()
    .oneOf(['WEBSITE', 'PHONE_CALL', 'WEBSITE_AND_PHONE_CALL', 'APP', 'WHATSAPP'], 'Invalid conversion location')
    .required('Conversion location is required'),
  optimization_goal: string()
    .oneOf(
      [
        'OFFSITE_CONVERSIONS',
        'LINK_CLICKS',
        'LANDING_PAGE_VIEWS',
        'VALUE',
        'QUALITY_CALL',
        'REACH',
        'CONVERSATIONS',
        'IMPRESSIONS',
      ],
      'Invalid performance goal'
    )
    .required('Performance goal is required'),
  // promoted_object: object().when('optimization_goal', {
  //   is: 'OFFSITE_CONVERSIONS',
  //   then: () => object()
  //     .shape({
  //       pixel_id: string().required('Pixel ID is required'),
  //       custom_event_type: string().required('Custom Event Type is required')
  //     })
  //     .required('Promoted object is required for OFFSITE_CONVERSIONS'),
  //   otherwise: () => object().when('optimization_goal', {
  //     is: 'QUALITY_CALL',
  //     then: () => object()
  //       .shape({
  //         page_id: string().required('Page ID is required for QUALITY_CALLS')
  //       })
  //       .required('Promoted object is required for QUALITY_CALLS')
  //   })
  // }),
  bid_amount: number().when('bid_strategy', {
    is: (val) => ['LOWEST_COST_WITH_BID_CAP', 'COST_CAP'].includes(val),
    then: schema => schema.required('Required').positive('must be a positive number'),
    otherwise: schema => schema.notRequired()
  }),
  roas_average_floor: number().when('bid_strategy', {
    is: 'LOWEST_COST_WITH_MIN_ROAS',
    then: schema => schema.required('Required').positive('must be a positive number'),
    otherwise: schema => schema.notRequired()
  }),
  billing_event: string()
    .oneOf(['IMPRESSIONS', 'LINK_CLICKS'], 'Invalid billing event')
    .required('Billing event is required'),
  budget: string().required('Budget type is required'),
  daily_budget: number().when('budget', {
    is: 'daily_budget',
    then: schema => schema.required('Daily budget is required').min(1, 'Daily budget must be a positive number'),
    otherwise: schema => schema.notRequired(),
  }),
  lifetime_budget: number().when('budget', {
    is: 'lifetime_budget',
    then: schema => schema.required('Lifetime budget is required').min(1, 'Lifetime budget must be a positive number'),
    otherwise: schema => schema.notRequired(),
  }),

  geo_locations: array().required('Location is required')
    .test('not-empty', 'Location is required', value => {
      return value && Object.keys(value).length > 0;
    })
});

const catalogueSalesFormSchema = object().shape({
  name: string().required('Ad Set name is required'),

  destination_type: string()
    .oneOf(['WEBSITE'], 'Invalid conversion location')
    .required('Conversion location is required'),

  optimization_goal: string()
    .oneOf(
      [
        'OFFSITE_CONVERSIONS',
        'VALUE',
      ],
      'Invalid performance goal'
    )
    .required('Performance goal is required'),

  billing_event: string()
    .oneOf(['IMPRESSIONS'], 'Invalid billing event')
    .required('Billing event is required'),

  budget: string().required('Budget type is required'),
  bid_amount: number().when('bid_strategy', {
    is: (val) => ['LOWEST_COST_WITH_BID_CAP', 'COST_CAP'].includes(val),
    then: schema => schema.required('Required').positive('must be a positive number'),
    otherwise: schema => schema.notRequired()
  }),
  roas_average_floor: number().when('bid_strategy', {
    is: 'LOWEST_COST_WITH_MIN_ROAS',
    then: schema => schema.required('Required').positive('must be a positive number'),
    otherwise: schema => schema.notRequired()
  }),
  daily_budget: number().when('budget', {
    is: 'daily_budget',
    then: schema => schema.required('Daily budget is required').min(1, 'Daily budget must be a positive number'),
    otherwise: schema => schema.notRequired(),
  }),

  lifetime_budget: number().when('budget', {
    is: 'lifetime_budget',
    then: schema => schema.required('Lifetime budget is required').min(1, 'Lifetime budget must be a positive number'),
    otherwise: schema => schema.notRequired(),
  }),
  geo_locations: array().required('Location is required')
    .test('not-empty', 'Location is required', value => {
      return value && Object.keys(value).length > 0;
    }),
});

const catalogueSalesCampaignFormSchema = object().shape({
  name: string().required('Ad Set name is required'),

  destination_type: string()
    .oneOf(['WEBSITE'], 'Invalid conversion location')
    .required('Conversion location is required'),

  optimization_goal: string()
    .oneOf(
      [
        'OFFSITE_CONVERSIONS',
        'VALUE',
      ],
      'Invalid performance goal'
    )
    .required('Performance goal is required'),

  billing_event: string()
    .oneOf(['IMPRESSIONS'], 'Invalid billing event')
    .required('Billing event is required'),

  budget: string().required('Budget type is required'),
  bid_amount: number().when('bid_strategy', {
    is: (val) => ['LOWEST_COST_WITH_BID_CAP', 'COST_CAP'].includes(val),
    then: schema => schema.required('Required').positive('must be a positive number'),
    otherwise: schema => schema.notRequired()
  }),
  roas_average_floor: number().when('bid_strategy', {
    is: 'LOWEST_COST_WITH_MIN_ROAS',
    then: schema => schema.required('Required').positive('must be a positive number'),
    otherwise: schema => schema.notRequired()
  }),
  daily_budget: number().when('budget', {
    is: 'daily_budget',
    then: schema => schema.required('Daily budget is required').min(1, 'Daily budget must be a positive number'),
    otherwise: schema => schema.notRequired(),
  }),

  lifetime_budget: number().when('budget', {
    is: 'lifetime_budget',
    then: schema => schema.required('Lifetime budget is required').min(1, 'Lifetime budget must be a positive number'),
    otherwise: schema => schema.notRequired(),
  }),
  geo_locations: array().required('Location is required')
    .test('not-empty', 'Location is required', value => {
      return value && Object.keys(value).length > 0;
    }),
});

const leadFormSchema = object().shape({
  name: string().required('Ad Set name is required'),
  destination_type: string()
    .oneOf(['WEBSITE', 'PHONE_CALL', 'ON_AD', 'WEBSITE_AND_PHONE_CALL', 'WEBSITE_AND_LEAD_FORM', 'APP', 'WHATSAPP'], 'Invalid conversion location')
    .required('Conversion location is required'),
  optimization_goal: string()
    .oneOf(
      [
        'OFFSITE_CONVERSIONS',
        'LINK_CLICKS',
        'LANDING_PAGE_VIEWS',
        'IMPRESSIONS',
        'QUALITY_CALL',
        'LEAD_GENERATION',
        'QUALITY_LEAD',
        'CONVERSATIONS',
        'REACH'
      ],
      'Invalid performance goal'
    )
    .required('Performance goal is required'),
  promoted_object: array().when('optimization_goal', {
    is: (goal) => goal === 'OFFSITE_CONVERSIONS',
    then: () =>
      array()
        .required('Promoted object is required for OFFSITE_CONVERSIONS'),
    otherwise: () => array().notRequired()
  }),
  facebookPages: array().when(['optimization_goal', 'destination_type'], {
    is: (goal, destinationType) => 
      ['QUALITY_CALL', 'QUALITY_LEAD', 'LEAD_GENERATION'].includes(goal) || destinationType === 'WHATSAPP',
    then: () =>
      array()
        .required('Facebook page id is required')
        .min(1, 'Facebook page id is required')
        .of(
          object().shape({
            adsAccountId: string().required('adsAccountId is required'),
            page_id: string().required('page_id is required for QUALITY_CALLS'),
          })
        )
        .test(
          'has-page-id',
          'At least one object must have page_id',
          (value) => value && value.some(obj => obj.page_id)
        ),
    otherwise: () => array().notRequired(),
  }),
  billing_event: string()
    .oneOf(['IMPRESSIONS', 'LINK_CLICKS'], 'Invalid billing event')
    .required('Billing event is required'),
  budget: string().required('Budget type is required'),
  bid_amount: number().when('bid_strategy', {
    is: (val) => ['LOWEST_COST_WITH_BID_CAP', 'COST_CAP'].includes(val),
    then: schema => schema.required('Required').positive('must be a positive number'),
    otherwise: schema => schema.notRequired()
  }),
  daily_budget: number().when('budget', {
    is: 'daily_budget',
    then: schema => schema.required('Daily budget is required').min(1, 'Daily budget must be a positive number'),
    otherwise: schema => schema.notRequired(),
  }),
  lifetime_budget: number().when('budget', {
    is: 'lifetime_budget',
    then: schema => schema.required('Lifetime budget is required').min(1, 'Lifetime budget must be a positive number'),
    otherwise: schema => schema.notRequired(),
  }),

  geo_locations: array().required('Location is required')
    .test('not-empty', 'Location is required', value => {
      return value && Object.keys(value).length > 0;
    })
});

const leadFormCampaignSchema = object().shape({
  name: string().required('Ad Set name is required'),
  destination_type: string()
    .oneOf(['WEBSITE', 'PHONE_CALL', 'ON_AD', 'WEBSITE_AND_PHONE_CALL', 'WEBSITE_AND_LEAD_FORM', 'APP', 'WHATSAPP'], 'Invalid conversion location')
    .required('Conversion location is required'),
  optimization_goal: string()
    .oneOf(
      [
        'OFFSITE_CONVERSIONS',
        'LINK_CLICKS',
        'LANDING_PAGE_VIEWS',
        'IMPRESSIONS',
        'QUALITY_CALL',
        'LEAD_GENERATION',
        'QUALITY_LEAD',
        'CONVERSATIONS',
        'REACH'
      ],
      'Invalid performance goal'
    )
    .required('Performance goal is required'),
  promoted_object: array().when('optimization_goal', {
      is: (goal) => goal === 'OFFSITE_CONVERSIONS',
      then: () =>
        array()
          .required('Promoted object is required for OFFSITE_CONVERSIONS'),
      otherwise: () => array().notRequired()
    }),
  facebookPages: array().when(['optimization_goal', 'destination_type'], {
      is: (goal, destinationType) => 
      ['QUALITY_CALL', 'QUALITY_LEAD', 'LEAD_GENERATION'].includes(goal) || destinationType === 'WHATSAPP',
      then: () =>
        array()
          .required('Facebook page id is required')
          .min(1, 'Facebook page id is required')
          .of(
            object().shape({
              adsAccountId: string().required('adsAccountId is required'),
              page_id: string().required('page_id is required for QUALITY_CALLS'),
            })
          )
          .test(
            'has-page-id',
            'At least one object must have page_id',
            (value) => value && value.some(obj => obj.page_id)
          ),
      otherwise: () => array().notRequired(),
    }),
  billing_event: string()
    .oneOf(['IMPRESSIONS', 'LINK_CLICKS'], 'Invalid billing event')
    .required('Billing event is required'),
  budget: string().required('Budget type is required'),
  bid_amount: number().when('bid_strategy', {
    is: (val) => ['LOWEST_COST_WITH_BID_CAP', 'COST_CAP'].includes(val),
    then: schema => schema.required('Required').positive('must be a positive number'),
    otherwise: schema => schema.notRequired()
  }),
  daily_budget: number().when('budget', {
    is: 'daily_budget',
    then: schema => schema.required('Daily budget is required').min(1, 'Daily budget must be a positive number'),
    otherwise: schema => schema.notRequired(),
  }),
  lifetime_budget: number().when('budget', {
    is: 'lifetime_budget',
    then: schema => schema.required('Lifetime budget is required').min(1, 'Lifetime budget must be a positive number'),
    otherwise: schema => schema.notRequired(),
  }),

  geo_locations: array().required('Location is required')
    .test('not-empty', 'Location is required', value => {
      return value && Object.keys(value).length > 0;
    })
});

const leadFormUpdateSchema = object().shape({
  name: string().required('Ad Set name is required'),
  destination_type: string()
    .oneOf(['WEBSITE', 'PHONE_CALL', 'ON_AD', 'WEBSITE_AND_PHONE_CALL', 'WEBSITE_AND_LEAD_FORM', 'APP', 'WHATSAPP'], 'Invalid conversion location')
    .required('Conversion location is required'),
  optimization_goal: string()
    .oneOf(
      [
        'OFFSITE_CONVERSIONS',
        'LINK_CLICKS',
        'LANDING_PAGE_VIEWS',
        'IMPRESSIONS',
        'QUALITY_CALL',
        'LEAD_GENERATION',
        'QUALITY_LEAD',
        'CONVERSATIONS',
        'REACH'
      ],
      'Invalid performance goal'
    )
    .required('Performance goal is required'),
  billing_event: string()
    .oneOf(['IMPRESSIONS', 'LINK_CLICKS'], 'Invalid billing event')
    .required('Billing event is required'),
  budget: string().required('Budget type is required'),
  bid_amount: number().when('bid_strategy', {
    is: (val) => ['LOWEST_COST_WITH_BID_CAP', 'COST_CAP'].includes(val),
    then: schema => schema.required('Required').positive('must be a positive number'),
    otherwise: schema => schema.notRequired()
  }),
  daily_budget: number().when('budget', {
    is: 'daily_budget',
    then: schema => schema.required('Daily budget is required').min(1, 'Daily budget must be a positive number'),
    otherwise: schema => schema.notRequired(),
  }),
  lifetime_budget: number().when('budget', {
    is: 'lifetime_budget',
    then: schema => schema.required('Lifetime budget is required').min(1, 'Lifetime budget must be a positive number'),
    otherwise: schema => schema.notRequired(),
  }),

  geo_locations: array().required('Location is required')
    .test('not-empty', 'Location is required', value => {
      return value && Object.keys(value).length > 0;
    })
});

const leadFormSchematrackEdit = object().shape({
  name: string().required('Ad Set name is required'),
  destination_type: string()
    .oneOf(['WEBSITE', 'PHONE_CALL', 'ON_AD', 'WEBSITE_AND_PHONE_CALL', 'WEBSITE_AND_LEAD_FORM', 'APP', 'WHATSAPP'], 'Invalid conversion location')
    .required('Conversion location is required'),
  optimization_goal: string()
    .oneOf(
      [
        'OFFSITE_CONVERSIONS',
        'LINK_CLICKS',
        'LANDING_PAGE_VIEWS',
        'IMPRESSIONS',
        'QUALITY_CALL',
        'LEAD_GENERATION',
        'QUALITY_LEAD',
        'CONVERSATIONS',
        'REACH'
      ],
      'Invalid performance goal'
    )
    .required('Performance goal is required'),
  // promoted_object: object().when('optimization_goal', {
  //   is: 'OFFSITE_CONVERSIONS',
  //   then: () => object()
  //     .shape({
  //       pixel_id: string().required('Pixel ID is required'),
  //       custom_event_type: string().required('Custom Event Type is required')
  //     })
  //     .required('Promoted object is required for OFFSITE_CONVERSIONS'),
  //   otherwise: () => object().when('optimization_goal', {
  //     is: 'QUALITY_CALL',
  //     then: () => object()
  //       .shape({
  //         page_id: string().required('Page ID is required for QUALITY_CALLS')
  //       })
  //       .required('Promoted object is required for QUALITY_CALLS')
  //   })
  // }),
  billing_event: string()
    .oneOf(['IMPRESSIONS', 'LINK_CLICKS'], 'Invalid billing event')
    .required('Billing event is required'),
  budget: string().required('Budget type is required'),
  bid_amount: number().when('bid_strategy', {
    is: (val) => ['LOWEST_COST_WITH_BID_CAP', 'COST_CAP'].includes(val),
    then: schema => schema.required('Required').positive('must be a positive number'),
    otherwise: schema => schema.notRequired()
  }),
  daily_budget: number().when('budget', {
    is: 'daily_budget',
    then: schema => schema.required('Daily budget is required').min(1, 'Daily budget must be a positive number'),
    otherwise: schema => schema.notRequired(),
  }),
  lifetime_budget: number().when('budget', {
    is: 'lifetime_budget',
    then: schema => schema.required('Lifetime budget is required').min(1, 'Lifetime budget must be a positive number'),
    otherwise: schema => schema.notRequired(),
  }),

  geo_locations: array().required('Location is required')
    .test('not-empty', 'Location is required', value => {
      return value && Object.keys(value).length > 0;
    })
});

const AppPromotionFormSchema = object().shape({
  name: string().required('Ad Set name is required'),
  destination_type: string()
    .oneOf(['APP'], 'Invalid conversion location')
    .required('Conversion location is required'),
  optimization_goal: string()
    .oneOf(
      [
        'OFFSITE_CONVERSIONS',
        'LINK_CLICKS',
        'APP_INSTALLS',
      ],
      'Invalid performance goal'
    )
    .required('Performance goal is required'),
  billing_event: string()
    .oneOf(['IMPRESSIONS'], 'Invalid billing event')
    .required('Billing event is required'),
  budget: string().required('Budget type is required'),
  bid_amount: number().when('bid_strategy', {
    is: (val) => ['LOWEST_COST_WITH_BID_CAP', 'COST_CAP'].includes(val),
    then: schema => schema.required('Required').positive('must be a positive number'),
    otherwise: schema => schema.notRequired()
  }),
  promoted_object: array().required('Location is required')
    .test('not-empty', 'promoted object is required', value => {
      return value && Object.keys(value).length > 0;
  }),
  daily_budget: number().when('budget', {
    is: 'daily_budget',
    then: schema => schema.required('Daily budget is required').min(1, 'Daily budget must be a positive number'),
    otherwise: schema => schema.notRequired(),
  }),
  lifetime_budget: number().when('budget', {
    is: 'lifetime_budget',
    then: schema => schema.required('Lifetime budget is required').min(1, 'Lifetime budget must be a positive number'),
    otherwise: schema => schema.notRequired(),
  }),

  geo_locations: array().required('Location is required')
    .test('not-empty', 'Location is required', value => {
      return value && Object.keys(value).length > 0;
  })
});

const AppPromotionFormUpdateSchema = object().shape({
  name: string().required('Ad Set name is required'),
  destination_type: string()
    .oneOf(['APP'], 'Invalid conversion location')
    .required('Conversion location is required'),
  optimization_goal: string()
    .oneOf(
      [
        'OFFSITE_CONVERSIONS',
        'LINK_CLICKS',
        'APP_INSTALLS',
      ],
      'Invalid performance goal'
    )
    .required('Performance goal is required'),
  billing_event: string()
    .oneOf(['IMPRESSIONS'], 'Invalid billing event')
    .required('Billing event is required'),
  budget: string().required('Budget type is required'),
  bid_amount: number().when('bid_strategy', {
    is: (val) => ['LOWEST_COST_WITH_BID_CAP', 'COST_CAP'].includes(val),
    then: schema => schema.required('Required').positive('must be a positive number'),
    otherwise: schema => schema.notRequired()
  }),
  daily_budget: number().when('budget', {
    is: 'daily_budget',
    then: schema => schema.required('Daily budget is required').min(1, 'Daily budget must be a positive number'),
    otherwise: schema => schema.notRequired(),
  }),
  lifetime_budget: number().when('budget', {
    is: 'lifetime_budget',
    then: schema => schema.required('Lifetime budget is required').min(1, 'Lifetime budget must be a positive number'),
    otherwise: schema => schema.notRequired(),
  }),
  geo_locations: array().required('Location is required')
    .test('not-empty', 'Location is required', value => {
      return value && Object.keys(value).length > 0;
  })
});

const AppPromotionFormSchematrackEdit = object().shape({
  name: string().required('Ad Set name is required'),
  destination_type: string()
    .oneOf(['APP'], 'Invalid conversion location')
    .required('Conversion location is required'),
  optimization_goal: string()
    .oneOf(
      [
        'OFFSITE_CONVERSIONS',
        'LINK_CLICKS',
        'APP_INSTALLS',
      ],
      'Invalid performance goal'
    )
    .required('Performance goal is required'),
  billing_event: string()
    .oneOf(['IMPRESSIONS'], 'Invalid billing event')
    .required('Billing event is required'),
  budget: string().required('Budget type is required'),
  bid_amount: number().when('bid_strategy', {
    is: (val) => ['LOWEST_COST_WITH_BID_CAP', 'COST_CAP'].includes(val),
    then: schema => schema.required('Required').positive('must be a positive number'),
    otherwise: schema => schema.notRequired()
  }),
  daily_budget: number().when('budget', {
    is: 'daily_budget',
    then: schema => schema.required('Daily budget is required').min(1, 'Daily budget must be a positive number'),
    otherwise: schema => schema.notRequired(),
  }),
  lifetime_budget: number().when('budget', {
    is: 'lifetime_budget',
    then: schema => schema.required('Lifetime budget is required').min(1, 'Lifetime budget must be a positive number'),
    otherwise: schema => schema.notRequired(),
  }),

  promoted_object: object()
    .required('Promoted object is required')
    .test('not-empty', 'Promoted object cannot be empty', value => {
      return value && Object.keys(value).length > 0;
  }),
  geo_locations: array().required('Location is required')
    .test('not-empty', 'Location is required', value => {
      return value && Object.keys(value).length > 0;
  })
});

const AwarenessSchema = object().shape({
  name: string().required('Ad Set name is required'),
  optimization_goal: string()
    .oneOf(
      [
        'REACH',
        'IMPRESSIONS',
        'AD_RECALL_LIFT',
        'THRUPLAY',
        'TWO_SECOND_CONTINUOUS_VIDEO_VIEWS'
      ],
      'Invalid performance goal'
    )
    .required('Performance goal is required'),
  promoted_object: array()
    .required('Facebook page id is required')
    .min(1, 'Facebook page id is required')
    .of(
      object().shape({
        page_id: string()
          .trim()
          .required('page_id is required')
      })
    ),
  billing_event: string()
    .oneOf(["IMPRESSIONS", "THRUPLAY", "TWO_SECOND_CONTINUOUS_VIDEO_VIEWS"], 'Invalid billing event')
    .required('Billing event is required'),
  budget: string().required('Budget type is required'),
  bid_amount: number().when('bid_strategy', {
    is: (val) => ['LOWEST_COST_WITH_BID_CAP', 'COST_CAP'].includes(val),
    then: schema => schema.required('Required').positive('must be a positive number'),
    otherwise: schema => schema.notRequired()
  }),
  daily_budget: number().when('budget', {
    is: 'daily_budget',
    then: schema => schema.required('Daily budget is required').min(1, 'Daily budget must be a positive number'),
    otherwise: schema => schema.notRequired(),
  }),
  lifetime_budget: number().when('budget', {
    is: 'lifetime_budget',
    then: schema => schema.required('Lifetime budget is required').min(1, 'Lifetime budget must be a positive number'),
    otherwise: schema => schema.notRequired(),
  }),

  geo_locations: array().required('Location is required')
    .test('not-empty', 'Location is required', value => {
      return value && Object.keys(value).length > 0;
    })
});

const AwarenessCampaignSchema = object().shape({
  name: string().required('Ad Set name is required'),
  optimization_goal: string()
    .oneOf(
      [
        'REACH',
        'IMPRESSIONS',
        'AD_RECALL_LIFT',
        'THRUPLAY',
        'TWO_SECOND_CONTINUOUS_VIDEO_VIEWS'
      ],
      'Invalid performance goal'
    )
    .required('Performance goal is required'),
  promoted_object: array()
    .required('Facebook page id is required')
    .min(1, 'Facebook page id is required')
    .of(
      object().shape({
        page_id: string()
          .trim()
          .required('page_id is required')
      })
    ),
  billing_event: string()
    .oneOf(["IMPRESSIONS", "THRUPLAY", "TWO_SECOND_CONTINUOUS_VIDEO_VIEWS"], 'Invalid billing event')
    .required('Billing event is required'),
  budget: string().required('Budget type is required'),
  bid_amount: number().when('bid_strategy', {
    is: (val) => ['LOWEST_COST_WITH_BID_CAP', 'COST_CAP'].includes(val),
    then: schema => schema.required('Required').positive('must be a positive number'),
    otherwise: schema => schema.notRequired()
  }),
  daily_budget: number().when('budget', {
    is: 'daily_budget',
    then: schema => schema.required('Daily budget is required').min(1, 'Daily budget must be a positive number'),
    otherwise: schema => schema.notRequired(),
  }),
  lifetime_budget: number().when('budget', {
    is: 'lifetime_budget',
    then: schema => schema.required('Lifetime budget is required').min(1, 'Lifetime budget must be a positive number'),
    otherwise: schema => schema.notRequired(),
  }),

  geo_locations: array().required('Location is required')
    .test('not-empty', 'Location is required', value => {
      return value && Object.keys(value).length > 0;
    })
});

const AwarenessSchematrackEdit = object().shape({
  name: string().required('Ad Set name is required'),
  optimization_goal: string()
    .oneOf(
      [
        'REACH',
        'IMPRESSIONS',
        'AD_RECALL_LIFT',
        'THRUPLAY',
        'TWO_SECOND_CONTINUOUS_VIDEO_VIEWS'
      ],
      'Invalid performance goal'
    ).required('Performance goal is required'),
  billing_event: string()
    .oneOf(["IMPRESSIONS", "THRUPLAY", "TWO_SECOND_CONTINUOUS_VIDEO_VIEWS"], 'Invalid billing event')
    .required('Billing event is required'),
  budget: string().required('Budget type is required'),
  bid_amount: number().when('bid_strategy', {
    is: (val) => ['LOWEST_COST_WITH_BID_CAP', 'COST_CAP'].includes(val),
    then: schema => schema.required('Required').positive('must be a positive number'),
    otherwise: schema => schema.notRequired()
  }),
  daily_budget: number().when('budget', {
    is: 'daily_budget',
    then: schema => schema.required('Daily budget is required').min(1, 'Daily budget must be a positive number'),
    otherwise: schema => schema.notRequired(),
  }),
  lifetime_budget: number().when('budget', {
    is: 'lifetime_budget',
    then: schema => schema.required('Lifetime budget is required').min(1, 'Lifetime budget must be a positive number'),
    otherwise: schema => schema.notRequired(),
  }),

  geo_locations: array().required('Location is required')
    .test('not-empty', 'Location is required', value => {
      return value && Object.keys(value).length > 0;
    })
});

const AwarenessFormUpdateSchema = object().shape({
  name: string().required('Ad Set name is required'),
  optimization_goal: string()
    .oneOf(
      [
        'REACH',
        'IMPRESSIONS',
        'AD_RECALL_LIFT',
        'THRUPLAY',
        'TWO_SECOND_CONTINUOUS_VIDEO_VIEWS'
      ],
      'Invalid performance goal'
    )
    .required('Performance goal is required'),
  billing_event: string()
    .oneOf(["IMPRESSIONS", "THRUPLAY", "TWO_SECOND_CONTINUOUS_VIDEO_VIEWS"], 'Invalid billing event')
    .required('Billing event is required'),
  budget: string().required('Budget type is required'),
  bid_amount: number().when('bid_strategy', {
    is: (val) => ['LOWEST_COST_WITH_BID_CAP', 'COST_CAP'].includes(val),
    then: schema => schema.required('Required').positive('must be a positive number'),
    otherwise: schema => schema.notRequired()
  }),
  daily_budget: number().when('budget', {
    is: 'daily_budget',
    then: schema => schema.required('Daily budget is required').min(1, 'Daily budget must be a positive number'),
    otherwise: schema => schema.notRequired(),
  }),
  lifetime_budget: number().when('budget', {
    is: 'lifetime_budget',
    then: schema => schema.required('Lifetime budget is required').min(1, 'Lifetime budget must be a positive number'),
    otherwise: schema => schema.notRequired(),
  }),

  geo_locations: array().required('Location is required')
    .test('not-empty', 'Location is required', value => {
      return value && Object.keys(value).length > 0;
    })
});

const EngagementSchema = object().shape({
  name: string().required('Ad Set name is required'),
  optimization_goal: string()
    .oneOf(
      [
        'QUALITY_CALL',
        'THRUPLAY',
        'OFFSITE_CONVERSIONS',
        'LINK_CLICKS',
        'PAGE_LIKES',
      ],
      'Invalid performance goal'
    )
    .required('Performance goal is required'),
  promoted_object: array()
    .when(['optimization_goal'], {
      is: (optimization_goal) => optimization_goal === 'OFFSITE_CONVERSIONS',
      then: () =>
        array()
          .required('Promoted object is required for OFFSITE_CONVERSIONS')
      ,
      otherwise: () => array().when('optimization_goal', {
        is: (value) => ['QUALITY_CALL', 'PAGE_LIKES'].includes(value),
        then: () => array()
          .required('Facebook page id is required')
          .min(1, 'Facebook page id is required')
          .of(
            object().shape({
              page_id: string()
                .trim()
                .required('page_id is required')
            })
          ),
        otherwise: () => array().notRequired()
      })
    }),
  billing_event: string()
    .oneOf(["IMPRESSIONS", "THRUPLAY", "LINK_CLICKS"], 'Invalid billing event')
    .required('Billing event is required'),
  budget: string().required('Budget type is required'),
  bid_amount: number().when('bid_strategy', {
    is: (val) => ['LOWEST_COST_WITH_BID_CAP', 'COST_CAP'].includes(val),
    then: schema => schema.required('Required').positive('must be a positive number'),
    otherwise: schema => schema.notRequired()
  }),
  daily_budget: number().when('budget', {
    is: 'daily_budget',
    then: schema => schema.required('Daily budget is required').min(1, 'Daily budget must be a positive number'),
    otherwise: schema => schema.notRequired(),
  }),
  lifetime_budget: number().when('budget', {
    is: 'lifetime_budget',
    then: schema => schema.required('Lifetime budget is required').min(1, 'Lifetime budget must be a positive number'),
    otherwise: schema => schema.notRequired(),
  }),

  geo_locations: array().required('Location is required')
    .test('not-empty', 'Location is required', value => {
      return value && Object.keys(value).length > 0;
    })
});

const EngagementCampaignSchema = object().shape({
  name: string().required('Ad Set name is required'),
  optimization_goal: string()
    .oneOf(
      [
        'QUALITY_CALL',
        'THRUPLAY',
        'OFFSITE_CONVERSIONS',
        'LINK_CLICKS',
        'PAGE_LIKES',
      ],
      'Invalid performance goal'
    )
    .required('Performance goal is required'),
  promoted_object: array()
    .when(['optimization_goal'], {
      is: (optimization_goal) => optimization_goal === 'OFFSITE_CONVERSIONS',
      then: () =>
        array()
          .required('Promoted object is required for OFFSITE_CONVERSIONS')
      ,
      otherwise: () => array().when('optimization_goal', {
        is: (value) => ['QUALITY_CALL', 'PAGE_LIKES'].includes(value),
        then: () => array()
          .required('Facebook page id is required')
          .min(1, 'Facebook page id is required')
          .of(
            object().shape({
              page_id: string()
                .trim()
                .required('page_id is required')
            })
          ),
        otherwise: () => array().notRequired()
      })
    }),
  billing_event: string()
    .oneOf(["IMPRESSIONS", "THRUPLAY", "LINK_CLICKS"], 'Invalid billing event')
    .required('Billing event is required'),
  budget: string().required('Budget type is required'),
  bid_amount: number().when('bid_strategy', {
    is: (val) => ['LOWEST_COST_WITH_BID_CAP', 'COST_CAP'].includes(val),
    then: schema => schema.required('Required').positive('must be a positive number'),
    otherwise: schema => schema.notRequired()
  }),
  daily_budget: number().when('budget', {
    is: 'daily_budget',
    then: schema => schema.required('Daily budget is required').min(1, 'Daily budget must be a positive number'),
    otherwise: schema => schema.notRequired(),
  }),
  lifetime_budget: number().when('budget', {
    is: 'lifetime_budget',
    then: schema => schema.required('Lifetime budget is required').min(1, 'Lifetime budget must be a positive number'),
    otherwise: schema => schema.notRequired(),
  }),

  geo_locations: array().required('Location is required')
    .test('not-empty', 'Location is required', value => {
      return value && Object.keys(value).length > 0;
    })
});

const EngagementFormUpdateSchema = object().shape({
  name: string().required('Ad Set name is required'),
  optimization_goal: string()
    .oneOf(
      [
        'QUALITY_CALL',
        'THRUPLAY',
        'OFFSITE_CONVERSIONS',
        'LINK_CLICKS',
        'PAGE_LIKES',
      ],
      'Invalid performance goal'
    )
    .required('Performance goal is required'),
  billing_event: string()
    .oneOf(["IMPRESSIONS", "THRUPLAY", "LINK_CLICKS"], 'Invalid billing event')
    .required('Billing event is required'),
  budget: string().required('Budget type is required'),
  bid_amount: number().when('bid_strategy', {
    is: (val) => ['LOWEST_COST_WITH_BID_CAP', 'COST_CAP'].includes(val),
    then: schema => schema.required('Required').positive('must be a positive number'),
    otherwise: schema => schema.notRequired()
  }),
  daily_budget: number().when('budget', {
    is: 'daily_budget',
    then: schema => schema.required('Daily budget is required').min(1, 'Daily budget must be a positive number'),
    otherwise: schema => schema.notRequired(),
  }),
  lifetime_budget: number().when('budget', {
    is: 'lifetime_budget',
    then: schema => schema.required('Lifetime budget is required').min(1, 'Lifetime budget must be a positive number'),
    otherwise: schema => schema.notRequired(),
  }),

  geo_locations: array().required('Location is required')
    .test('not-empty', 'Location is required', value => {
      return value && Object.keys(value).length > 0;
    })
});

const EngagementSchematrackEdit = object().shape({
  name: string().required('Ad Set name is required'),
  optimization_goal: string()
    .oneOf(
      [
        'QUALITY_CALL',
        'THRUPLAY',
        'OFFSITE_CONVERSIONS',
        'LINK_CLICKS',
        'PAGE_LIKES',
      ],
      'Invalid performance goal'
    )
    .required('Performance goal is required'),
  billing_event: string()
    .oneOf(["IMPRESSIONS", "THRUPLAY", "LINK_CLICKS"], 'Invalid billing event')
    .required('Billing event is required'),
  budget: string().required('Budget type is required'),
  bid_amount: number().when('bid_strategy', {
    is: (val) => ['LOWEST_COST_WITH_BID_CAP', 'COST_CAP'].includes(val),
    then: schema => schema.required('Required').positive('must be a positive number'),
    otherwise: schema => schema.notRequired()
  }),
  daily_budget: number().when('budget', {
    is: 'daily_budget',
    then: schema => schema.required('Daily budget is required').min(1, 'Daily budget must be a positive number'),
    otherwise: schema => schema.notRequired(),
  }),
  lifetime_budget: number().when('budget', {
    is: 'lifetime_budget',
    then: schema => schema.required('Lifetime budget is required').min(1, 'Lifetime budget must be a positive number'),
    otherwise: schema => schema.notRequired(),
  }),

  geo_locations: array().required('Location is required')
    .test('not-empty', 'Location is required', value => {
      return value && Object.keys(value).length > 0;
    })
});

const TrafficSchema = object().shape({
  name: string().required('Ad Set name is required'),
  optimization_goal: string()
    .oneOf(
      [
        'QUALITY_CALL',
        'LINK_CLICKS',
      ],
      'Invalid performance goal'
    )
    .required('Performance goal is required'),
  billing_event: string()
    .oneOf(["IMPRESSIONS", "LINK_CLICKS"], 'Invalid billing event')
    .required('Billing event is required'),
  budget: string().required('Budget type is required'),
  bid_amount: number().when('bid_strategy', {
    is: (val) => ['LOWEST_COST_WITH_BID_CAP', 'COST_CAP'].includes(val),
    then: schema => schema.required('Required').positive('must be a positive number'),
    otherwise: schema => schema.notRequired()
  }),
  daily_budget: number().when('budget', {
    is: 'daily_budget',
    then: schema => schema.required('Daily budget is required').min(1, 'Daily budget must be a positive number'),
    otherwise: schema => schema.notRequired(),
  }),
  lifetime_budget: number().when('budget', {
    is: 'lifetime_budget',
    then: schema => schema.required('Lifetime budget is required').min(1, 'Lifetime budget must be a positive number'),
    otherwise: schema => schema.notRequired(),
  }),

  geo_locations: array().required('Location is required')
    .test('not-empty', 'Location is required', value => {
      return value && Object.keys(value).length > 0;
    })
});

const TrafficCampaignSchema = object().shape({
  name: string().required('Ad Set name is required'),
  optimization_goal: string()
    .oneOf(
      [
        'QUALITY_CALL',
        'LINK_CLICKS',
      ],
      'Invalid performance goal'
    )
    .required('Performance goal is required'),
  billing_event: string()
    .oneOf(["IMPRESSIONS", "LINK_CLICKS"], 'Invalid billing event')
    .required('Billing event is required'),
  budget: string().required('Budget type is required'),
  bid_amount: number().when('bid_strategy', {
    is: (val) => ['LOWEST_COST_WITH_BID_CAP', 'COST_CAP'].includes(val),
    then: schema => schema.required('Required').positive('must be a positive number'),
    otherwise: schema => schema.notRequired()
  }),
  daily_budget: number().when('budget', {
    is: 'daily_budget',
    then: schema => schema.required('Daily budget is required').min(1, 'Daily budget must be a positive number'),
    otherwise: schema => schema.notRequired(),
  }),
  lifetime_budget: number().when('budget', {
    is: 'lifetime_budget',
    then: schema => schema.required('Lifetime budget is required').min(1, 'Lifetime budget must be a positive number'),
    otherwise: schema => schema.notRequired(),
  }),

  geo_locations: array().required('Location is required')
    .test('not-empty', 'Location is required', value => {
      return value && Object.keys(value).length > 0;
    })
});

const adFormSchema = object({
  source: string().oneOf(['CATALOG', 'MYDRIVE'], 'Invalid Creative Source option').required(),
  accounts: array()
    .of(
      object({
        adsAccountId: string().required(),
        page_id: string().trim().required('Facebook page is required'),
        instagram_user_id: string().nullable().optional(),
      })
    )
    .min(1, 'Select at least one account'),
});

const createRuleSchema = object({
  ruleName: string().required('Rule name is required'),
  applyTo: string().required('Please select where to apply the rule'),
  action: string().required('Please select an action'),
  budgetAmount: string().when('action', {
    is: (action) => ['DECREASE_DAY', 'DECREASE_LIFETIME', 'INCREASE_DAY', 'INCREASE_LIFETIME'].includes(action),
    then: () => string().required('Required'),
    otherwise: () => string().notRequired(),
  }),
  maxLifetimeBudgetCap: string().when('action', {
    is: (action) => ['DECREASE_DAY', 'DECREASE_LIFETIME', 'INCREASE_DAY', 'INCREASE_LIFETIME'].includes(action),
    then: () => string().required('Required'),
    otherwise: () => string().notRequired(),
  }),
  conditionField: string().required('Condition field is required'),
  conditionOperator: string().required('Condition operator is required'),
  conditionValue: string()
    .when('conditionOperator', {
      is: (value) => value === 'GREATER_THAN' || value === 'LESS_THAN',
      then: () => string().required('Required'),
      otherwise: () => string().notRequired(),
    }),
  conditionValue1: string()
    .when('conditionOperator', {
      is: (value) => value === 'IN_RANGE' || value === 'NOT_IN_RANGE',
      then: () => string().required('Required'),
      otherwise: () => string().notRequired(),
    }),
  conditionValue2: string()
    .when('conditionOperator', {
      is: (value) => value === 'IN_RANGE' || value === 'NOT_IN_RANGE',
      then: () => string().required('Required'),
      otherwise: () => string().notRequired(),
    }),
  timeRange: string().required('Please select a time range'),
  schedule: string().required('Please select a schedule'),
  customSchedules: array().of(
    object().shape({
      // days: array().min(1, 'At least one day must be selected'),
      timeSlots: array().of(
        object().shape({
          // startTime: string().required('Start time is required'),
          // endTime: string().required('End time is required'),
        })
      ).min(1, 'At least one time slot must be added'),
    })
  ),
});

export {
  adAccountRequestSchema,
  adFormSchema,
  adUplaodSchema,
  AppPromotionFormSchema,
  AppPromotionFormSchematrackEdit,
  AppPromotionFormUpdateSchema,
  approvalCardSchema,
  approveTopUpSchema,
  assignClientSchema,
  AwarenessCampaignSchema,
  AwarenessFormUpdateSchema,
  AwarenessSchema,
  AwarenessSchematrackEdit,
  bankDetailsIndianFormSchema,
  bankDetailsIndianMandateFormSchema,
  bankDetailsNonIndianFormSchema,
  campaignFormSchema,
  catalogueSalesFormSchema,
  catalogueSalesCampaignFormSchema,
  commisionFormSchema,
  confirmTopUpSchema,
  createRuleSchema,
  editAdAccountRequestSchema,
  editRequestSchema,
  EngagementCampaignSchema,
  EngagementFormUpdateSchema,
  EngagementSchema,
  EngagementSchematrackEdit,
  leadFormCampaignSchema,
  leadFormSchema,
  leadFormSchematrackEdit,
  leadFormUpdateSchema,
  legalDetailsIndianFormSchema,
  legalDetailsIndianVerificationSchema,
  legalDetailsNonIndianFormSchema,
  legalDetailsNonIndianVerificationSchema,
  loginSchema,
  newAccountSchema,
  newClientSchema,
  newCompanySchema,
  replyToRequestSchema,
  requestSchema,
  salesCampaignFormSchema,
  salesFormSchema,
  salesFormSchematrackEdit,
  salesFormUpdateSchema,
  signUpschema,
  topUpRequestSchema,
  topUpRequestSchemaForNonIndian,
  TrafficCampaignSchema,
  TrafficSchema,
  transferFormSchema,
};

